import CryptoJs from 'crypto-js'

export default {
  getWords (val, wordsList) {
    if (wordsList.length) {
      for (let i = 0; i < wordsList.length; i++) {
        if (val.indexOf(wordsList[i]) !== -1) {
          return true
        }
      }
    } else {
      return false
    }
  },
  /**
   * 加密
   */
  encryptDes (message, key = 'keiHG$93') {
    const keyHex = CryptoJs.enc.Utf8.parse(key)
    const option = { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 }
    const encrypted = CryptoJs.DES.encrypt(message, keyHex, option)
    return encrypted.ciphertext.toString() // 返回hex格式密文，如需返回base64格式：encrypted.toString()
  },
  /**
   * 解密
   */
  decryptDes (message, key = 'keiHG$93') {
    const keyHex = CryptoJs.enc.Utf8.parse(key)
    const decrypted = CryptoJs.DES.decrypt(
      {
        ciphertext: CryptoJs.enc.Hex.parse(message)
      },
      keyHex,
      {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
      }
    )
    return decrypted.toString(CryptoJs.enc.Utf8)
  }
}
